<span
    class="ql-formats"
    *ngrxLet="{
        isDisabled: isDisabled$,
        isTableFormatterAvailable: isTableFormatterAvailable$,
        isFontColorFormatterAvailable: isFontColorFormatterAvailable$,
        isLinkFormatterAvailable: isLinkFormatterAvailable$
    } as vm"
>
    <button type="button" class="ql-bold" [disabled]="vm.isDisabled"></button>
    <button type="button" class="ql-italic" [disabled]="vm.isDisabled"></button>
    <button type="button" class="ql-underline" [disabled]="vm.isDisabled"></button>
    <button type="button" class="ql-strike" [disabled]="vm.isDisabled"></button>
    <select *ngIf="vm.isFontColorFormatterAvailable" class="ql-color" [disabled]="vm.isDisabled"></select>

    <select class="ql-align" [title]="'dtmUi.quillEditor.alignmentTitle' | transloco" [disabled]="vm.isDisabled">
        <option selected></option>
        <option value="center"></option>
        <option value="right"></option>
        <option value="justify"></option>
    </select>

    <select class="ql-size" [disabled]="vm.isDisabled">
        <option value="small">12px</option>
        <option selected>14px</option>
        <option value="large">20px</option>
        <option value="huge">36px</option>
    </select>

    <button type="button" class="ql-list" value="ordered" [disabled]="vm.isDisabled"></button>
    <button type="button" class="ql-list" value="bullet" [disabled]="vm.isDisabled"></button>
    <button type="button" class="ql-indent" value="-1" [disabled]="vm.isDisabled"></button>
    <button type="button" class="ql-indent" value="+1" [disabled]="vm.isDisabled"></button>
    <button type="button" class="ql-image" [disabled]="vm.isDisabled"></button>
    <button *ngIf="vm.isLinkFormatterAvailable" type="button" class="ql-link" [disabled]="vm.isDisabled"></button>
    <select *ngIf="vm.isTableFormatterAvailable" class="ql-table" [disabled]="vm.isDisabled"></select>

    <ng-content></ng-content>
</span>
